import client from '../client'

export async function bid({ auctionId, bidAmount, acceptedPrices }) {
  return client(`${process.env.NEXT_PUBLIC_AUCTION_DOMAIN}/api/Auctions/Bid`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ auctionId, bidAmount, acceptedPrices }),
  })
}
